/* Sérénelle · pop-up −10 %, inscription, onglet */
(() => {
  'use strict';
  const pop = document.getElementById('lisPop');
  const onglet = document.getElementById('lisPopOnglet');
  const CODE = 'SERENELLE10';
  const CLE = 'serenelle-pop';
  const lire = () => { try { return JSON.parse(localStorage.getItem(CLE) || 'null'); } catch (e) { return null; } };
  const ecrire = (v) => { try { localStorage.setItem(CLE, JSON.stringify(v)); } catch (e) { /* navigation privée */ } };
  const mailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());

  /* Inscription : formulaire client Shopify (tags newsletter), sans recharger la page */
  const inscrire = (email, tags) => {
    const fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email.trim());
    fd.append('contact[tags]', tags);
    return fetch('/contact#contact_form', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(() => null);
  };
  /* Applique le code au panier/paiement sans que la cliente ait à le recopier */
  const appliquer = () => fetch('/discount/' + CODE, { credentials: 'same-origin' }).catch(() => null);

  if (pop) {
    const boite = pop.querySelector('.lis-pop-boite');
    const e1 = pop.querySelector('.lis-pop-etape1');
    const e2 = pop.querySelector('.lis-pop-etape2');
    const form = pop.querySelector('form');
    const champ = pop.querySelector('input[type="email"]');
    const err = pop.querySelector('.lis-pop-err');
    let avant = null, ouvert = false, minuteur = 0;

    const etat = lire();
    const recent = etat && etat.ferme && Date.now() - etat.ferme < 3 * 864e5;
    const inscrite = etat && etat.inscrite;

    const montrerOnglet = (v) => { if (onglet) onglet.hidden = !v || inscrite; };

    const ouvrir = () => {
      if (ouvert) return;
      ouvert = true;
      clearTimeout(minuteur);
      avant = document.activeElement;
      pop.hidden = false;
      document.documentElement.classList.add('lis-pop-ouvert');
      montrerOnglet(false);
      requestAnimationFrame(() => { (e2.hidden ? champ : pop.querySelector('.lis-pop-code')).focus({ preventScroll: true }); });
    };
    const fermer = () => {
      if (!ouvert) return;
      ouvert = false;
      pop.hidden = true;
      document.documentElement.classList.remove('lis-pop-ouvert');
      const s = lire() || {};
      if (!s.inscrite) { s.ferme = Date.now(); ecrire(s); montrerOnglet(true); }
      if (avant && avant.focus) avant.focus({ preventScroll: true });
    };

    pop.addEventListener('click', (e) => {
      const f = e.target.closest('[data-ferme]');
      if (f) { if (f.tagName !== 'A') e.preventDefault(); fermer(); }
    });
    document.addEventListener('keydown', (e) => {
      if (!ouvert) return;
      if (e.key === 'Escape') { fermer(); return; }
      if (e.key === 'Tab') {
        const f = Array.from(boite.querySelectorAll('a[href],button,input')).filter((x) => x.offsetParent !== null);
        if (!f.length) return;
        const a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!mailOk(champ.value)) { err.hidden = false; champ.setAttribute('aria-invalid', 'true'); champ.focus(); return; }
      err.hidden = true; champ.removeAttribute('aria-invalid');
      const btn = form.querySelector('button');
      btn.disabled = true;
      await Promise.all([inscrire(champ.value, 'newsletter,popup-10'), appliquer()]);
      ecrire({ inscrite: true });
      e1.hidden = true; e2.hidden = false;
      pop.querySelector('.lis-pop-code').focus({ preventScroll: true });
    });

    const code = pop.querySelector('.lis-pop-code');
    code.addEventListener('click', async () => {
      const lab = code.querySelector('span');
      try { await navigator.clipboard.writeText(CODE); lab.textContent = 'Copié ✓'; }
      catch (x) { lab.textContent = CODE; }
      setTimeout(() => { lab.textContent = 'Copier'; }, 2200);
    });

    document.querySelectorAll('[data-pop]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); ouvrir(); }));
    if (onglet) onglet.addEventListener('click', ouvrir);

    /* Déclenchement : après 15 s, à 45 % de la page, ou intention de sortie (ordinateur). Jamais pendant l'animation du patch. */
    const patch = document.getElementById('lisPatch');
    const surPatch = () => { if (!patch) return false; const r = patch.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; };
    const peutOuvrir = () => !ouvert && !surPatch() && !document.documentElement.classList.contains('lis-pop-ouvert');
    const tenter = () => { if (peutOuvrir()) ouvrir(); else minuteur = setTimeout(tenter, 2500); };
    if (inscrite) montrerOnglet(false);
    else if (recent) montrerOnglet(true);
    else {
      minuteur = setTimeout(tenter, 15000);
      const auDefil = () => {
        const h = document.documentElement.scrollHeight - innerHeight;
        if (h > 0 && scrollY / h > 0.45) { removeEventListener('scroll', auDefil); tenter(); }
      };
      addEventListener('scroll', auDefil, { passive: true });
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 8) tenter(); }, { once: true });
      }
    }
  }

  /* Inscription du pied de page */
  document.querySelectorAll('.lis-pied-news').forEach((f) => {
    f.addEventListener('submit', async (e) => {
      e.preventDefault();
      const champ = f.querySelector('input');
      if (!mailOk(champ.value)) { champ.setAttribute('aria-invalid', 'true'); champ.focus(); return; }
      champ.removeAttribute('aria-invalid');
      await inscrire(champ.value, 'newsletter,pied-de-page');
      const merci = document.createElement('p');
      merci.className = 'lis-pied-merci';
      merci.setAttribute('role', 'status');
      merci.textContent = 'Merci ! Votre code de bienvenue : ' + CODE;
      f.replaceWith(merci);
    });
  });
})();
